export enum PlayerCard {
  INDEX = '/player-card',
  SEARCH_PLAYERS = '/search/players',
}
